require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.match");

module.exports = function chop(str, step) {
  if (str == null) return [];
  str = String(str);
  step = ~~step;
  return step > 0 ? str.match(new RegExp('.{1,' + step + '}', 'g')) : [str];
};